import { Card, Icon, IconButton, Modal } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import PropTypes from "prop-types";
import { toDate, toDateTime } from "utils/DateUtils";
import { formatarCpfCnpj } from "utils/Functions";
import { formatPhoneNumber } from "utils/NumberUtils";


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90vw',
    maxWidth: '1000px',
    borderRadius: 4,
    boxShadow: 24,
    p: 4,
    maxHeight: '90vh',
    overflowY: 'auto',
};

function Changes({
    show,
    close,
    header,
    dados }) {

    const parseAlteracoes = (json) => {
        try {
            return JSON.parse(json);
        } catch (e) {
            return [];
        }
    };

    const alteracoes = parseAlteracoes(dados);

    function formatField(field, type) {
        if (!field) return null;

        if (Array.isArray(field)) {
            return field.map(f => (typeof f === 'object' ? f.nome : f)).join(', ');
        }

        if (type === 'field') return field;
        if (type === 'fieldDateTime') return toDateTime(field);
        if (type === 'fieldDate') return toDate(field);
        if (type === 'fieldDocument') return formatarCpfCnpj(field);
        if (type === 'fiedlPhone') return formatPhoneNumber(field);
        return field;
    }


    return (
        <Modal
            open={show}
            onClose={close}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Card sx={style}>
                <MDTypography id="modal-modal-title" variant="h6" component="h2" mb={3}>
                    {header}
                </MDTypography>
                <IconButton
                    aria-label="close"
                    onClick={close}
                    sx={{ position: 'absolute', top: 8, right: 8 }}
                >
                    <MDTypography variant="body1" lineHeight={1}>
                        <Icon color="light">close</Icon>
                    </MDTypography>
                </IconButton>

                <MDBox sx={{ maxHeight: 600, overflowY: "auto", padding: 2 }}>
                    {alteracoes.map((item, index) => (
                        <MDBox
                            key={index}
                            mb={2}
                            p={2}
                            sx={{
                                border: "1px solid #e0e0e0",
                                borderRadius: 2,
                            }}
                        >
                            <MDTypography variant="button" fontWeight="bold">
                                {item.value}
                            </MDTypography>
                            <MDTypography variant="body2">
                                De:{" "}
                                <span style={{ color: "red" }}>
                                    {formatField(item.de, item.tipo) ?? "(vazio)"}
                                </span>
                            </MDTypography>
                            <MDTypography variant="body2">
                                Para:{" "}
                                <span style={{ color: "green" }}>
                                    {formatField(item.para, item.tipo) ?? "(vazio)"}
                                </span>
                            </MDTypography>
                        </MDBox>
                    ))}
                </MDBox>
            </Card>
        </Modal>
    );
}

Changes.propTypes = {
    show: PropTypes.bool.isRequired,
    close: PropTypes.func.isRequired,
    header: PropTypes.string.isRequired,
    dados: PropTypes.string.isRequired,
};

export default Changes;
